import(/* webpackMode: "eager" */ "/vercel/path0/app/feature-requests/page.tsx")